"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCsvColumnList = function (_a) {
    var csvData = _a.csvData, index = _a.index, indexKey = _a.indexKey, itemKeyList = _a.itemKeyList;
    var dataList = [];
    var currentData = csvData[index];
    if (itemKeyList.filter(function (k) { return !!currentData[k]; }).length === 0)
        return dataList;
    if (index < csvData.length - 1) {
        var j = 0;
        var _loop_1 = function () {
            var nextItem = csvData[index + j];
            if (itemKeyList.filter(function (k) { return !!nextItem[k]; }).length > 0) {
                var newItem_1 = {};
                itemKeyList.forEach(function (k) {
                    newItem_1[k] = nextItem[k] || currentData[k];
                });
                dataList.push(newItem_1);
            }
            j++;
        };
        do {
            _loop_1();
        } while (csvData[index + j] && !csvData[index + j][indexKey]);
    }
    return dataList;
};
exports.parseUom = function (s) {
    return s && s[0].toLowerCase() === 'l' ? 'LBR' : 'KGM';
};
//# sourceMappingURL=utils.js.map